import { SCornerstoneHero, SDetails, SImage, SLeftColumn, STitle } from './CornerstoneHero.styled'
import { CORNERSTONES, CornerstoneType } from 'components/cornerstone/CornerstoneUtils'
import { Caption, Title_h1_default } from 'components/Typography'
import React, { Children, cloneElement, FC, isValidElement, ReactNode } from 'react'

export type CornerstoneHeroProps = {
  title?: string | null
  children?: ReactNode
  image?: ReactNode
  cornerstoneType?: CornerstoneType
  caption?: string
  className?: string
}

export const CornerstoneHero: FC<React.PropsWithChildren<CornerstoneHeroProps>> = (props) => {
  return (
    <SCornerstoneHero className={props.className}>
      <SLeftColumn>
        {!!props.caption && <Caption>{props.caption}</Caption>}
        <STitle variant={Title_h1_default} as={'h1'}>
          {props.title}
        </STitle>
        <SDetails>
          {Children.map(props.children, (item) => {
            if (isValidElement(item) && props.cornerstoneType) {
              return cloneElement(item, {
                ...CORNERSTONES[props.cornerstoneType].theme,
              })
            }
            return item
          })}
        </SDetails>
      </SLeftColumn>
      <SImage>{props.image}</SImage>
    </SCornerstoneHero>
  )
}
